import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Form, Input, Tooltip, Select, Row, Col, Button, Avatar, Divider } from 'antd';
import { countryArray, isdArray } from '../constants/countries';
import { LoadingSpinner } from '../presentation/LoadingSpinner';
import {
  ShopOutlined,
  PhoneOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { analytics } from '../modules/analytics';
// import { pageviewGA, eventGA } from '../modules/ganalytics';


// const FormItem = Form.Item;
const { Option } = Select;

//
// class UserProfileEditForm extends React.Component {
//   static propTypes = {
//     email: PropTypes.string,
//     profile: PropTypes.shape({
//       profile: PropTypes.shape({
//         name: PropTypes.string,
//         avatarInitials: PropTypes.string,
//         address1: PropTypes.string,
//         address2: PropTypes.string,
//         city: PropTypes.string,
//         zipcode: PropTypes.string,
//         state: PropTypes.string,
//         country: PropTypes.string,
//         phonePrefix: PropTypes.string,
//         phone: PropTypes.string,
//       }),
//       status: PropTypes.string.isRequired, // loading -> idle -> updating -> idle
//     }).isRequired,
//
//     getProfile: PropTypes.func,
//     updateProfile: PropTypes.func,
//
//     onFormSubmit: PropTypes.func,
//     onFormCancel: PropTypes.func,
//   };
//
//   onFormSubmit = (e) => {
//     e.preventDefault();
//     this.props.form.validateFields((err, values) => {
//       if (!err) {
//         this.props.onFormSubmit(values);
//       }
//     });
//   }
//
//   onFormCancel = () => {
//     this.props.onFormCancel();
//   }
//
//   render() {
//     const { profile, status } = this.props.profile;
//     const { getFieldDecorator } = this.props.form;
//
//     const formItemLayout = {
//       labelCol: {
//         xs: { span: 24 },
//         sm: { span: 8 },
//       },
//       wrapperCol: {
//         xs: { span: 24 },
//         sm: { span: 16 },
//       },
//     };
//     const tailFormItemLayout = {
//       wrapperCol: {
//         xs: {
//           span: 24,
//           offset: 0,
//         },
//         sm: {
//           span: 16,
//           offset: 8,
//         },
//       },
//     };
//
//     const countryOptions = countryArray.map((country) =>
//       <Option key={country.name} value={country.name}>{country.name}</Option>
//     );
//
//     const phonePrefixOptions = isdArray.map((isd) =>
//       <Option key={isd} value={isd}>{isd}</Option>
//     );
//
//     const prefixSelector = getFieldDecorator('phonePrefix', {
//       initialValue: profile.phonePrefix,
//     })(
//       <Select style={{ width: 100 }}>
//         {phonePrefixOptions}
//       </Select>
//     );
//
//     return (
//
//       <Form onSubmit={this.onFormSubmit}>
//
//         <Row>
//           <Col {...tailFormItemLayout.wrapperCol} >
//             <h4 className="mb-4">Update Your Profile</h4>
//           </Col>
//         </Row>
//
//         <FormItem
//           {...formItemLayout}
//           label="Full Name"
//         >
//           {getFieldDecorator('name', {
//             initialValue: profile.name,
//             rules: [{
//               type: 'string', message: 'Enter Your Name',
//             }, {
//               required: true, message: 'Your name cannot be blank',
//             }, {
//               max: 127, message: 'Shorter name preferred',
//             }, {
//               min: 2, message: 'Too short',
//             }],
//           })(
//             <Input />
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label={(
//             <span>
//               Initials&nbsp;
//               <Tooltip title="Appears on your avatar">
//                 <Icon type="question-circle-o" />
//               </Tooltip>
//             </span>
//           )}
//         >
//           {getFieldDecorator('avatarInitials', {
//             initialValue: profile.avatarInitials,
//             rules: [{
//               type: 'string', message: 'Use plain characters',
//             }, {
//               max: 2, message: 'Make it shorter',
//             }],
//           })(
//             <Input />
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label="Address"
//         >
//           {getFieldDecorator('address1', {
//             initialValue: profile.address1,
//             rules: [{
//               max: 256, message: 'Too long',
//             }],
//           })(
//             <Input />
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label="Address Line 2"
//         >
//           {getFieldDecorator('address2', {
//             initialValue: profile.address2,
//             rules: [{
//               max: 128, message: 'Too long',
//             }],
//           })(
//             <Input />
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label="City"
//         >
//           {getFieldDecorator('city', {
//             initialValue: profile.city,
//             rules: [{
//               max: 48, message: 'Too long',
//             }],
//           })(
//             <Input />
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label="Zip"
//         >
//           {getFieldDecorator('zipcode', {
//             initialValue: profile.zipcode,
//             rules: [],
//           })(
//             <Input />
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label="State"
//         >
//           {getFieldDecorator('state', {
//             initialValue: profile.state,
//             rules: [{
//               max: 128, message: 'Too long',
//             }],
//           })(
//             <Input />
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label="Country"
//         >
//           {getFieldDecorator('country', {
//             initialValue: profile.country,
//             rules: [],
//           })(
//             <Select
//               showSearch={true}
//               allowClear={true}
//               filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
//             >
//               { countryOptions }
//             </Select>
//           )}
//         </FormItem>
//
//         <FormItem
//           {...formItemLayout}
//           label="Phone Number"
//         >
//           {getFieldDecorator('phone', {
//             initialValue: profile.phone,
//             rules: [],
//           })(
//             <Input addonBefore={prefixSelector} style={{ width: '100%' }} />
//           )}
//         </FormItem>
//
//         <FormItem {...tailFormItemLayout}>
//           <Button
//             type="primary"
//             htmlType="submit"
//             className="mr-4"
//             icon={(status === 'updating') ? 'loading' : 'check'}
//           >
//             { (status === 'updating') ? 'Updating' : 'Update' }
//           </Button>
//           <Button
//             type="secondary"
//             icon="close"
//             onClick={this.onFormCancel}
//           >
//             Cancel Editing
//           </Button>
//         </FormItem>
//       </Form>
//     );
//   }
// }
//
// const WrappedUserProfileEditForm = Form.create()(UserProfileEditForm);
// const WrappedUserProfileEditForm = null;

export class UserProfile extends React.Component {
  state = {
    view: 'preview', // preview -> edit -> preview
  };
  static propTypes = {
    profile: PropTypes.shape({
      profile: PropTypes.shape({
        name: PropTypes.string,
        avatarInitials: PropTypes.string,
        email: PropTypes.string,
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        zipcode: PropTypes.string,
        state: PropTypes.string,
        country: PropTypes.string,
        phonePrefix: PropTypes.string,
        phone: PropTypes.string,
      }),
      status: PropTypes.string.isRequired, // loading -> idle -> updating -> idle
    }).isRequired,

    getProfile: PropTypes.func,
    updateProfile: PropTypes.func,
  };


  componentDidMount() {
    analytics.trackView('/user/profile');
    this.props.getProfile();
  }

  componentDidUpdate(prevProps) {
    const { status } = this.props.profile;

    if (prevProps.networkError && !this.props.networkError) {
      this.props.getProfile();
      if (this.state.view === 'edit') {
        this.setState({ view: 'preview' });
      }
    }

    if (prevProps.profile.status === 'updating' && status === 'loaded') {
      if (this.state.view === 'edit') {
        this.setState({ view: 'preview' });
      }
    }
  }

  onEditClick = () => {
    if (this.state.view === 'preview') {
      this.setState({ view: 'edit' });
    }
  }

  onFormSubmit = (values) => {
    // eventGA({
    //   category: 'account',
    //   action: 'user_profile_updated',
    // });
    this.props.updateProfile(values);
  }

  onFormCancel = () => {
    if (this.state.view === 'edit') {
      this.setState({ view: 'preview' });
    }
  }


  render() {
    const { status, profile } = this.props.profile;

    const isLoading = status === 'loading';
    if (isLoading) {
      return <LoadingSpinner />;
    }

    // <WrappedUserProfileEditForm
    //   {...this.props}
    //   onFormSubmit={this.onFormSubmit}
    //   onFormCancel={this.onFormCancel}
    // />

    if (this.state.view === 'edit') {
      const fLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      };
      const tLayout = {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 16, offset: 8 },
        },
      };
      return (
        <div>
          <Helmet>
            <title>Updating My Profile</title>
          </Helmet>
          <div className="text-center mb-4"><h4>Update Your Profile</h4></div>

          <Form onFinish={this.onFormSubmit} initialValues={{
            name: profile.name,
            avatarInitials: profile.avatarInitials,
            address1: profile.address1,
            address2: profile.address2,
            city: profile.city,
            state: profile.state,
            country: profile.country,
            zipcode: profile.zipcode,
            phone: profile.phone,
          }}>

            <Form.Item {...fLayout} label="Full name" name="name" rules={[
              { type: 'string', message: 'Enter Your Name' },
              { required: true, message: 'Your name cannot be blank' },
              { max: 127, message: 'Shorter name preferred' },
              { min: 2, message: 'Too short'},
            ]}>
              <Input />
            </Form.Item>

            <Form.Item
              {...fLayout}
              label="Avatar" name="avatarInitials"
              extra="Initials that appear on your avatar."
              rules={[
                { type: 'string', message: 'Use plain characters' },
                { max: 2, message: 'Make it shorter', },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              {...fLayout} label="Address" name="address1"
              rules={[
                { max: 256, message: 'Too long' },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              {...tLayout} name="address2" extra="Line #2"
              rules={[
                { max: 256, message: 'Too long' },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item {...fLayout} label="City" name="city">
              <Input />
            </Form.Item>

            <Form.Item {...fLayout} label="State" name="state">
              <Input />
            </Form.Item>

            <Form.Item {...fLayout} label="Country" name="country">
              <Input />
            </Form.Item>

            <Form.Item {...fLayout} label="Zip" name="zipcode">
              <Input />
            </Form.Item>

            <Form.Item {...fLayout} label="Phone" name="phone">
              <Input />
            </Form.Item>

            <Form.Item {...tLayout}>
              <Button type="primary" icon={<CheckOutlined />} loading={status==="updating"} htmlType="submit" className="mr-3">
                Update
              </Button>
              <Button type="link" icon={<CloseOutlined />} onClick={this.onFormCancel}>
                Cancel
              </Button>
            </Form.Item>

          </Form>
        </div>
      );
    }

    return (
      <div>
        <Helmet>
          <title>My Profile</title>
        </Helmet>
        <div>

          <div className="mb-4 d-flex align-items-start">
            <Avatar className="mr-3 mr-md-3">{ profile.avatarInitials }</Avatar>
            <div>
              <h4 className="m-0">{ profile.name }</h4>
              <div className="text-dark">{ profile.email }</div>
            </div>
          </div>

          <Divider orientation="left" className="mt-5"><ShopOutlined /><span className="ml-3">Address</span></Divider>

          <div>
            { (profile.address1 || profile.address2) ? (
              <div>
                <div className="text-dark">{ profile.address1 }</div>
                <div className="text-dark">{ profile.address2 }</div>
              </div>
            ) : (
              <span className="text-secondary">No street address</span>
            )}
          </div>

          <div>
            { (profile.city || profile.zipcode) ? (
              <div>
                <span className="text-dark mr-3">{ profile.city }</span>
                <span className="text-dark">{ profile.zipcode }</span>
              </div>
            ) : (
              <span className="text-secondary">No city / zipcode</span>
            )}
          </div>

          <div>
            { (profile.state || profile.country) ? (
              <div>
                <span className="text-dark mr-3">{ profile.state }</span>
                <span className="text-dark">{ profile.country }</span>
              </div>
            ) : (
              <span className="text-secondary">No state / country</span>
            )}
          </div>

          <Divider orientation="left" className="mt-4"><PhoneOutlined /><span className="ml-3">Phone</span></Divider>

          <div className="my-2">
            { (profile.phonePrefix || profile.phone) ? (
              <div>
                <span className="text-secondary mr-1">{ profile.phonePrefix }</span>
                <span className="text-dark">{ profile.phone }</span>
              </div>
            ) : (
              <span className="text-secondary">No phone number added on file</span>
            )}
          </div>

          <Button
            className="my-3"
            icon={<EditOutlined />}
            type="primary"
            onClick={this.onEditClick}
          >
            Update
          </Button>

          <div className="mt-3 text-secondary text-small">
            We don't share or sell your contact details with third parties or use them for any promotion.
          </div>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/presentation/UserProfile.jsx